
<template>
    <v-container fluid>
    <v-card elevation="0" flat tile>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="6">
                        <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="6" align=right>
                            <v-btn
                            class="button-shadow mr-1"
                            color="secondary"
                            @click="isAddFile = true"
                            >
                            Add
                            </v-btn>
                            <v-btn
                                class="button-shadow mr-1"
                                :to="`/${route}/list`"
                                replace
                                color="primary"
                            >
                                Done
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-data-table
                sort-by="filerank"
                :headers="header_files"
                :items="data_files"
                :items-per-page="500"
                :footer-props="footer"
                :loading="isReceiving"
                class="elevation-0"
            >
                <template v-slot:top>
                    <v-dialog v-model="isDeleteFile" width="500">
                        <v-card>
                            <v-card-title> Delete this File? </v-card-title>
                            <v-card-text>
                            {{ delete_file.filename }}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="isDeleteFile = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    color="secondary"
                                    class="button-shadow"
                                    @click="deleteFile(delete_file)"
                                    >Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template v-slot:item.filetype="{ item }">
                    <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                        <v-icon size="50" color="primary">mdi-file-pdf-box</v-icon>
                    </a>    
                </template>             
                <template v-slot:item.filesize="{ item }">
                    {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                </template>
                <template v-slot:item.createdAt="{ item }">
                    {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        icon
                        color="primary"
                        @click="editFileDialog(item)"
                        >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="primary"
                        @click="deleteFileDialog(item)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <div>
        <v-dialog
            v-model="isAddFile"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Add File</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="1">
                            <v-text-field
                                v-model="add_file.filerank"
                                class="mb-4"
                                placeholder="Num"
                                type="number"
                                oninput="if(this.value < 0) this.value = 0;"
                                single-line
                                hint="Num"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                            v-model="add_file.filename"
                            label="File Name"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-file-input label="File input" v-on:change="onChangeUploadFile" accept=".pdf" />
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isAddFile=false; add_file={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="addFile"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="isEditFile"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Edit File</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="1">
                            <v-text-field
                            v-model="edit_file.filerank"
                            v-on:change="onChangeFile($event, 'filerank')"
                            class="mb-4"
                            placeholder="Num"
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Num"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                            v-model="edit_file.filename"
                            v-on:change="onChangeFile($event, 'filename')"
                            label="File Name"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-file-input label="File input" v-model="edit_fileupload" v-on:change="onChangeUploadFileEdit" accept="image/*" />
                        </v-col>

                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isEditFile=false; edit_file={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="editFile"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    components: {

    },
    props: {
        files: {
            type: Array
        },
        id: String,
        route: String,
    },
    computed: {
        ...mapState('File', ['isReceiving']),
    },
    data () {
        return {
            header_files: [
                { text: "#", value: "filerank", width: "10px" },
                { text: "File", value: "filetype", width: "8%" },
                { text: "Name", value: "filename" },
                { text: "Size", value: "filesize", width: "10%" },
                { text: "Created", value: "createdAt", width: "10%" },
                { text: "Actions", value: "actions", sortable: false, width: "10%"  },
            ],
            data_files: [],
            edit_fileupload: null,
            isAddFile: false,
            isDeleteFile: false,
            isEditFile: false,
            add_file: {},
            delete_file: {},
            edit_file: {},
            change_file: {},
            footer: {'items-per-page-options': [500, 1000, 5000]},
        }
    },
    methods: {
        ...mapActions('File', [ 'insertFileRequest', 'deleteFileRequest', 'updateFileRequest', 'updateFileWithImageRequest']),
        async addFile() {
            this.isAddFile = false;
            this.add_file.id = this.id;
            this.add_file.route = this.route;
            let result = await this.insertFileRequest(this.add_file);
            if(result!=null) this.data_files.splice(0,0,result);
            this.add_file = {};
        },
        deleteFileDialog(item) {
            this.isDeleteFile = true;
            this.delete_file = { _id: item._id, filename: item.filename };
        },
        async deleteFile(item) {
            this.isDeleteFile = false;
            let result = await this.deleteFileRequest(item);
            let index = this.data_files.findIndex((i) => i._id == result._id);
            this.data_files.splice(index, 1);
        },
        editFileDialog(item) {
            this.isEditFile = true;
            this.edit_file = Object.assign({},item);
        },
        async editFile() {
            this.isEditFile = false;
            let result;
            this.change_file.id = this.edit_file._id;
            if(this.change_file.file!=null) result = await this.updateFileWithImageRequest(this.change_file);
            else result = await this.updateFileRequest(this.change_file);
            let index = this.data_files.findIndex((i)=> i._id == result._id);
            this.data_files.splice(index, 1, result);
        },
        onChangeFile(value, field){
            this.change_file[field] = value;
        },
        onChangeUploadFile(image) {
            if (!image) this.add_file.file = null;
            else this.add_file.file = image;
        },
        onChangeUploadFileEdit(image) {
            if (!image) this.change_file.file = null;
            else this.change_file.file = image;
        },
    },
    created(){
        this.data_files = Object.assign([], this.files);
    }
}
</script>